export interface LinkFavicon {
  rel: string;
  sizes?: string;
  href: string;
  type?: string;
  color?: string;
}

export function getIconsData(folder: string): LinkFavicon[] {
  return [
    {rel: 'apple-touch-icon', sizes: '180x180', href: `/assets/favicon/${folder}apple-touch-icon.png`},
    {rel: 'icon', type: 'image/png', sizes: '32x32', href: `/assets/favicon/${folder}favicon-32x32.png`},
    {rel: 'icon', type: 'image/png', sizes: '16x16', href: `/assets/favicon/${folder}favicon-16x16.png`},
    {rel: 'shortcut icon', href: `/assets/favicon/${folder}favicon.ico`},
    {rel: 'manifest', href: `/assets/favicon/${folder}site.webmanifest`},
    {rel: 'mask-icon', href: `/assets/favicon/${folder}safari-pinned-tab.svg`, color: '#ff0000'}
  ];
}

export function changeFavicons(document: Document, leagueAlias: string): void {
  let folder = '';
  if (leagueAlias === 'ablmoscow') {
    folder = 'abl/';
  }
  const data = getIconsData(folder);
  for (const item of data) {
    const link = document.createElement('link');
    for (const key of Object.keys(item)) {
      link.setAttribute(key, item[key]);
    }
    document.head.appendChild(link);
  }
}
